import React from 'react';
import { BUILD_VERSION, formatBuildStampDisplay, isBuildStampNew } from '../utils/appBuildStamp';
import './BuildStampLabel.scss';

export default function BuildStampLabel({ className = '', style, title }) {
  const isNew = isBuildStampNew(BUILD_VERSION);
  const display = formatBuildStampDisplay(BUILD_VERSION);
  const classes = ['build-stamp-label', isNew ? 'build-stamp-label--new' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={classes}
      style={style}
      title={title || (isNew ? 'Yeni sürüm yüklendi' : `Derleme: ${display}`)}
    >
      {display}
      {isNew && <span className="build-stamp-label__badge">yeni</span>}
    </span>
  );
}
